import { env } from '@/shared/config'

/**
 * Where goauth answers.
 *
 * Until 1.4.1 it served no CORS headers at all, so the panel had to reach it
 * same-origin through a dev/prod proxy. That version added `ALLOW_DOMAINS`, and
 * with the panel's origin listed there the browser can call it directly — which
 * is what `VITE_GOAUTH_URL` now points at.
 *
 * Left empty, the base falls back to the panel's own origin: the arrangement
 * where something in front routes `/auth` and `/admin` to goauth on one host.
 * That still works and needs no CORS at all.
 */
export const goauthBase = env.VITE_GOAUTH_URL || (globalThis.location?.origin ?? '')
